import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { __ } from '@wordpress/i18n';
import { useContextSystem } from '@wp-g2/context';
import { cx } from '@wp-g2/styles';
import { createUnitValue, is, noop } from '@wp-g2/utils';
import React from 'react';
import * as styles from './font-size-control-styles';
import { getInputValue, getSelectOptions, getSelectValueFromFontSize, hasUnit, isCustomSelectedItem, isCustomValue } from './font-size-control-utils';
export function useFontSizeControl(props) {
  var _fontSizes$;

  var _useContextSystem = useContextSystem(props, 'FontSizeControl'),
      className = _useContextSystem.className,
      _useContextSystem$cus = _useContextSystem.customLabel,
      customLabel = _useContextSystem$cus === void 0 ? __('Custom') : _useContextSystem$cus,
      disableCustomFontSizes = _useContextSystem.disableCustomFontSizes,
      _useContextSystem$dis = _useContextSystem.disabled,
      disabled = _useContextSystem$dis === void 0 ? false : _useContextSystem$dis,
      _useContextSystem$fon = _useContextSystem.fontSizes,
      fontSizes = _useContextSystem$fon === void 0 ? [] : _useContextSystem$fon,
      isPreviewable = _useContextSystem.isPreviewable,
      _useContextSystem$lab = _useContextSystem.label,
      label = _useContextSystem$lab === void 0 ? __('Font size') : _useContextSystem$lab,
      _useContextSystem$max = _useContextSystem.max,
      max = _useContextSystem$max === void 0 ? 100 : _useContextSystem$max,
      maxWidth = _useContextSystem.maxWidth,
      _useContextSystem$min = _useContextSystem.min,
      min = _useContextSystem$min === void 0 ? 1 : _useContextSystem$min,
      minWidth = _useContextSystem.minWidth,
      _useContextSystem$onC = _useContextSystem.onChange,
      onChange = _useContextSystem$onC === void 0 ? noop : _useContextSystem$onC,
      onClose = _useContextSystem.onClose,
      onOpen = _useContextSystem.onOpen,
      placeholder = _useContextSystem.placeholder,
      size = _useContextSystem.size,
      value = _useContextSystem.value,
      _useContextSystem$wit = _useContextSystem.withSlider,
      withSlider = _useContextSystem$wit === void 0 ? false : _useContextSystem$wit,
      otherProps = _objectWithoutProperties(_useContextSystem, ["className", "customLabel", "disableCustomFontSizes", "disabled", "fontSizes", "isPreviewable", "label", "max", "maxWidth", "min", "minWidth", "onChange", "onClose", "onOpen", "placeholder", "size", "value", "withSlider"]);

  var hasUnits = hasUnit(value || ((_fontSizes$ = fontSizes[0]) == null ? void 0 : _fontSizes$.size));
  var hasCustomValue = isCustomValue(fontSizes, value);
  var options = React.useMemo(function () {
    return getSelectOptions({
      options: fontSizes,
      disableCustomFontSizes: disableCustomFontSizes,
      hasCustomValue: hasCustomValue
    });
  }, [fontSizes, disableCustomFontSizes, hasCustomValue]);
  var handleOnReset = React.useCallback(function () {
    onChange(undefined);
  }, [onChange]);
  var handleOnChange = React.useCallback(function (_ref) {
    var selectedItem = _ref.selectedItem;
    if (isCustomSelectedItem(selectedItem)) return;

    if (hasUnits) {
      onChange(selectedItem.size);
    } else {
      if (is.defined(selectedItem.size)) {
        onChange(Number(selectedItem.size));
      } else {
        handleOnReset();
      }
    }
  }, [handleOnReset, hasUnits, onChange]);
  var handleOnInputChange = React.useCallback(function (next) {
    if (!next && next !== 0) {
      handleOnReset();
      return;
    }

    if (hasUnits) {
      onChange(createUnitValue(next, 'px'));
    } else {
      onChange(Number(next));
    }
  }, [handleOnReset, hasUnits, onChange]);
  var inputValue = getInputValue(fontSizes, value);
  var selectedFontSizeSlug = getSelectValueFromFontSize(fontSizes, value);
  var currentValue = options.find(function (option) {
    return option.key === selectedFontSizeSlug;
  });
  var isDefaultValue = !is.defined(value);
  var classes = cx(styles.FontSizeControl, className);
  var withSelect = fontSizes.length > 0;
  return _objectSpread(_objectSpread({}, otherProps), {}, {
    className: classes,
    customLabel: customLabel,
    disabled: disabled,
    inputValue: inputValue,
    isDefaultValue: isDefaultValue,
    label: label,
    max: max,
    min: min,
    onChange: handleOnChange,
    onInputChange: handleOnInputChange,
    onReset: handleOnReset,
    options: options,
    selectDropdownProps: {
      isPreviewable: isPreviewable,
      maxWidth: maxWidth,
      minWidth: minWidth,
      onClose: onClose,
      onOpen: onOpen,
      placeholder: placeholder
    },
    size: size,
    value: currentValue,
    withNumberInput: !withSlider && !disableCustomFontSizes,
    withSelect: withSelect,
    withSlider: withSlider
  });
}